import { render, staticRenderFns } from "./CardModalDescription.vue?vue&type=template&id=c5a4eba2&scoped=true"
import script from "./CardModalDescription.vue?vue&type=script&lang=js"
export * from "./CardModalDescription.vue?vue&type=script&lang=js"
import style0 from "./CardModalDescription.vue?vue&type=style&index=0&id=c5a4eba2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a4eba2",
  null
  
)

export default component.exports